import { NEW_PASSWORD } from 'dealer-reducers'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EstigroupLogoSvg from '../other/svg/EstigroupLogoSvg'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RootReducer } from 'src/redux/rootReducer'
import SignInButton from '../atoms/SignInButton'

const ResetPassword = (): JSX.Element => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [submittedEmail, setSubmittedEmail] = useState('')
  const isLoading = useSelector((state: RootReducer) => state.authReducer.isLoading)
  const error = useSelector((state: RootReducer) => state.authReducer.newPasswordError)
  const success = useSelector((state: RootReducer) => state.authReducer.newPasswordSuccess)
  const dispatch = useDispatch()

  const handleSubmit = (): void => {
    setSubmittedEmail(email)
    dispatch(NEW_PASSWORD({ email }))
  }

  return (
    <div className="w-screen h-screen pt-20 pb-9 bg-gradient-to-b from-sky-700 to-sky-800 inline-flex justify-center items-center gap-2.5">
      <div className="w-96 px-9 inline-flex flex-col justify-center items-start gap-16">
        <div className="w-full flex justify-center items-center">
          <EstigroupLogoSvg className="text-white" />
        </div>

        {success ? (
          <div
            className="w-full max-w-[500px] px-6 py-10 bg-white rounded-lg inline-flex flex-col justify-center items-center gap-3 overflow-hidden"
            style={{
              boxShadow:
                '0px 4px 8px 0px rgba(0,0,0,0.08), 0px 2px 4px 0px rgba(0,0,0,0.08), 0px 0px 0px 1px rgba(0,0,0,0.08)'
            }}>
            <div className="flex justify-center items-center">
              <svg width="95" height="86" viewBox="0 0 95 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_875_5852)">
                  <rect y="9.19849" width="88" height="64" rx="6" transform="rotate(-6 0 9.19849)" fill="white" />
                  <path
                    d="M13.4361 71.3847L87.3046 63.6208C92.2167 63.1045 93.7628 56.7075 89.6286 54.0049L56.3511 32.2509C50.2953 28.2922 42.2915 29.1334 37.1911 34.2647L9.16366 62.4621C5.73613 65.9105 8.43668 71.7158 13.2074 71.4038L13.4361 71.3847Z"
                    fill="white"
                    stroke="#52525B"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M6.90311 9.22708L80.7716 1.46318C85.6837 0.9469 88.526 6.88269 85.0441 10.3858L57.0167 38.5832C51.9163 43.7144 43.9124 44.5557 37.8566 40.597L4.57911 18.843C0.50952 16.1826 1.94407 9.94267 6.67538 9.25592L6.90311 9.22708Z"
                    fill="#E4E4E7"
                    stroke="#52525B"
                    strokeWidth="1.5"
                  />
                </g>
                <rect
                  x="0.824288"
                  y="9.86598"
                  width="86.5"
                  height="62.5"
                  rx="5.25"
                  transform="rotate(-6 0.824288 9.86598)"
                  stroke="#52525B"
                  strokeWidth="1.5"
                />
                <path d="M61.7876 76.447L66.3882 72.3672L72.4128 73.6L62.8297 59.0857L61.7876 76.447Z" fill="white" />
                <path
                  d="M66.3882 72.3672L72.4128 73.6L70.5 68.5L66.3882 72.3672L64.5 70.5"
                  stroke="#52525B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <defs>
                  <clipPath id="clip0_875_5852">
                    <rect y="9.19849" width="88" height="64" rx="6" transform="rotate(-6 0 9.19849)" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div className="self-stretch flex flex-col justify-start items-center">
              <div className="self-stretch text-center justify-start text-gray-700 text-xs font-semibold font-['Open_Sans'] leading-5">
                We sent email on {submittedEmail}
              </div>
            </div>

            <div className="self-stretch text-center justify-start text-blue-600 text-lg font-bold font-Montserrat">
              Click the link in the email to reset your password.
            </div>
          </div>
        ) : (
          <div className="w-full max-w-96 flex flex-col justify-center items-center gap-6">
            <div className="self-stretch text-center justify-center text-white text-xl font-semibold font-Montserrat leading-5">
              {t('sign_in_screen.forgot_password_description')}
            </div>

            <div className="self-stretch flex flex-col justify-start items-start gap-8">
              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="justify-center text-white text-sm font-medium font-Montserrat leading-5">E-mail</div>
                <div
                  className="self-stretch h-11 bg-white rounded-md inline-flex justify-center items-center overflow-hidden"
                  style={{
                    boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
                  }}>
                  <div className="flex-1 px-4 py-1.5 flex justify-center items-center gap-2">
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value)
                      }}
                      className="flex-1 justify-start outline-none bg-transparent text-gray-900 text-xs font-medium font-Montserrat leading-5"
                      placeholder=""
                    />
                  </div>
                </div>
                {error && (
                  <div className="text-red-400 font-medium text-sm relative top-1">
                    {t('sign_in_screen.email_invalid')}
                  </div>
                )}
              </div>
            </div>

            <SignInButton
              onClick={handleSubmit}
              disabled={isLoading}
              isLoading={isLoading}
              text={t('sign_in_screen.remind_password')}
            />

            <Link
              to="/sign-in"
              className="self-stretch px-6 py-4 bg-transparent rounded-md justify-center items-center gap-2 flex">
              <svg className="w-5 h-4" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 1L1 8L7 15M1 8H19"
                  stroke="currentColor"
                  strokeWidth="2"
                  color="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="justify-start text-white text-lg font-semibold font-Montserrat leading-5">
                Back to login page
              </div>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ResetPassword
